// Общая геометрия главного экрана между сценой PixiJS и DOM-слоем зон (без PixiJS — не тянет чанк сцены).
// homeBg — где на экране лежит фон гаража (cover, прижат к низу) и какой вариант (BG-GARAGE или -XL), в координатах окна.
import { signal } from '@preact/signals';

export interface ScreenRect { id: string; x: number; y: number; w: number; h: number }
export const homeBg = signal<ScreenRect | null>(null);
/**
 * Машина на главном: картинка, прямоугольник в координатах холста (CSS px, как app.screen) и прозрачность.
 * Рисует её DOM-слой зон (над картинками стадий), сцена только двигает; null — машины нет или она не картинкой.
 */
export const homeCar = signal<{ url: string; x: number; y: number; w: number; h: number; alpha: number } | null>(null);
/** Сколько DOM-слоёв показывают машину (счётчик: новый слой монтируется раньше, чем снимается старый); > 0 — сцена свою не рисует. */
export const carInDom = signal(0);
